module.exports = __webpack_public_path__ + "img/status5.27304b4a.png";